import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const data = [
  { month: 'Jul \'24', atRisk: 310, nearMisses: 12, firstAid: 8, compliance: 92 },
  { month: 'Aug \'24', atRisk: 330, nearMisses: 14, firstAid: 9, compliance: 94 },
  { month: 'Sep \'24', atRisk: 320, nearMisses: 13, firstAid: 10, compliance: 89 },
  { month: 'Oct \'24', atRisk: 345, nearMisses: 15, firstAid: 10, compliance: 87 },
  { month: 'Nov \'24', atRisk: 325, nearMisses: 13, firstAid: 9, compliance: 91 },
  { month: 'Dec \'24', atRisk: 340, nearMisses: 14, firstAid: 10, compliance: 93 },
  { month: 'Jan \'25', atRisk: 330, nearMisses: 12, firstAid: 9, compliance: 94 },
  { month: 'Feb \'25', atRisk: 335, nearMisses: 13, firstAid: 8, compliance: 92 },
  { month: 'Mar \'25', atRisk: 325, nearMisses: 11, firstAid: 8, compliance: 95 },
  { month: 'Apr \'25', atRisk: 320, nearMisses: 10, firstAid: 8, compliance: 96 },
  { month: 'May \'25', atRisk: 330, nearMisses: 12, firstAid: 8, compliance: 96 },
];

const MultiLineChart = () => (
  <ResponsiveContainer width="100%" height={300}>
    <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="month" />
      <YAxis yAxisId="left" />
      <YAxis yAxisId="right" orientation="right" domain={[80, 100]} />
      <Tooltip />
      <Legend />
      <Line yAxisId="left" type="monotone" dataKey="atRisk" stroke="#f59e0b" name="At-Risk Behaviors" />
      <Line yAxisId="left" type="monotone" dataKey="nearMisses" stroke="#3b82f6" name="Near Misses" />
      <Line yAxisId="left" type="monotone" dataKey="firstAid" stroke="#ec4899" name="First Aid" />
      <Line yAxisId="right" type="monotone" dataKey="compliance" stroke="#22C55E" name="Compliance %" />
    </LineChart>
  </ResponsiveContainer>
);

export default MultiLineChart;
